var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 7.79961C10.9882 7.79961 12.6 6.18783 12.6 4.19961C12.6 2.21138 10.9882 0.599609 8.99998 0.599609C7.01175 0.599609 5.39998 2.21138 5.39998 4.19961C5.39998 6.18783 7.01175 7.79961 8.99998 7.79961Z",
    fill: "#5E6E82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.599976 18.5996C0.599976 13.9604 4.36078 10.1996 8.99998 10.1996C13.6392 10.1996 17.4 13.9604 17.4 18.5996H0.599976Z",
    fill: "#5E6E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.6d77c8aad5dcf91d22b3912d0d17c3a8.svg";
export { ForwardRef as ReactComponent };